export const safePrefixes = {
  1: 'eth',
  2: 'exp',
  3: 'rop',
  4: 'rin',
  5: 'gor',
  6: 'kot',
  7: 'tch',
  8: 'ubq',
  9: 'tubq',
  10: 'oeth',
  11: 'meta',
  12: 'kal',
  13: 'dstg',
  14: 'flr',
  15: 'diode',
  16: 'cflr',
  17: 'tfi',
  18: 'TST',
  19: 'sgb',
  20: 'esc',
  21: 'esct',
  22: 'eladid',
  23: 'eladidt',
  24: 'kardiachain',
  25: 'cro',
  26: 'L1test',
  27: 'shib',
  28: 'BobaRinkeby',
  29: 'L1',
  30: 'rsk',
  31: 'trsk',
  32: 'GooDT',
  33: 'GooD',
  34: 'dth',
  35: 'tbwg',
  36: 'dx',
  37: 'xpla',
  38: 'val',
  39: 'u2u',
  40: 'TelosEVM',
  41: 'TelosEVMTestnet',
  42: 'lukso',
  43: 'pangolin',
  44: 'crab',
  45: 'pangoro',
  46: 'darwinia',
  47: 'aic',
  48: 'etmp',
  49: 'etmpTest',
  50: 'xdc',
  51: 'txdc',
  52: 'cet',
  53: 'tcet',
  54: 'OP',
  55: 'ZYX',
  56: 'bnb',
  57: 'sys',
  58: 'OntologyMainnet',
  59: 'eos-legacy',
  60: 'go',
  61: 'etc',
  62: 'tetc',
  63: 'metc',
  64: 'ellaism',
  65: 'tokt',
  66: 'okt',
  67: 'dbm',
  68: 'SO1',
  69: 'okov',
  70: 'hsc',
  71: 'cfxtest',
  72: 'dxc',
  73: 'FNCY',
  74: 'idchain',
  75: 'DSC',
  76: 'mix',
  77: 'spoa',
  78: 'primuschain',
  79: 'zenith',
  80: 'GeneChain',
  81: 'joc',
  82: 'Meter',
  83: 'MeterTest',
  84: 'linqto-devnet',
  85: 'gttest',
  86: 'gt',
  87: 'nnw',
  88: 'tomo',
  89: 'tomot',
  90: 'gar-s0',
  91: 'gar-s1',
  92: 'gar-s2',
  93: 'gar-s3',
  94: 'sdlt',
  95: 'camdl',
  96: 'bkc',
  97: 'bnbt',
  98: 'six',
  99: 'poa',
  100: 'gno',
  101: 'eti',
  102: 'tw3g',
  103: 'WLC',
  104: 'tklc',
  105: 'dw3g',
  106: 'vlx',
  107: 'ntn',
  108: 'TT',
  109: 'shibariumecosystem',
  110: 'xpr',
  111: 'ETL',
  112: 'coinbit',
  113: 'deh',
  114: 'c2flr',
  115: 'debank-testnet',
  116: 'debank-mainnet',
  117: 'auptick',
  118: 'arcology',
  119: 'enuls',
  120: 'enulst',
  121: 'REAL',
  122: 'fuse',
  123: 'spark',
  124: 'dwu',
  125: 'OYchainTestnet',
  126: 'OYchainMainnet',
  127: 'feth',
  128: 'heco',
  134: 'rlc',
  135: 'AlyxTestnet',
  136: 'deam',
  137: 'matic',
  138: 'dfio-meta-main',
  139: 'woop',
  141: 'OPtest',
  142: 'dax',
  144: 'PHI',
  148: 'shimmerevm-mainnet',
  150: 'sixt',
  151: 'rbn',
  152: 'rbn-devnet',
  153: 'rbn-testnet',
  154: 'rbn-tge',
  155: 'tenet-testnet',
  156: 'obe',
  160: 'eva',
  161: 'wall-e',
  162: 'tpht',
  163: 'pht',
  165: 'omni_testnet',
  167: 'atoshi',
  168: 'aioz',
  169: 'manta',
  170: 'hoosmartchain',
  172: 'resil',
  180: 'ame',
  186: 'Seele',
  188: 'BMC',
  189: 'BMCT',
  193: 'cem',
  195: 'tokb',
  196: 'okb',
  197: 'NEUTR',
  198: 'bit',
  199: 'BTT',
  200: 'aox',
  201: 'moactest',
  204: 'obnb',
  208: 'utx',
  210: 'BTN',
  211: 'EDI',
  212: 'makalu',
  217: 'SIN2',
  218: 'SO1-old',
  222: 'ASK',
  225: 'LA',
  226: 'TLA',
  230: 'SDX',
  236: 'deamtest',
  242: 'plgchain',
  246: 'ewt',
  248: 'OAS',
  250: 'ftm',
  255: 'kroma',
  256: 'hecot',
  258: 'setm',
  259: 'neon',
  262: 'SUR',
  269: 'hpb',
  271: 'EGONm',
  274: 'lachain',
  280: 'zksync-goerli',
  288: 'Boba',
  291: 'orderly',
  295: 'hedera-mainnet',
  296: 'hedera-testnet',
  297: 'hedera-previewnet',
  298: 'hedera-localnet',
  300: 'ogc',
  301: 'Bobaopera',
  303: 'ncnt',
  309: 'wyz',
  311: 'omax',
  313: 'ncn',
  314: 'filecoin',
  321: 'kcs',
  322: 'kcst',
  324: 'zksync',
  333: 'w3q',
  335: 'DFKTEST',
  336: 'sdn',
  338: 'tcro',
  345: 'YVM',
  361: 'theta-mainnet',
  363: 'theta-sapphire',
  364: 'theta-amber',
  365: 'theta-testnet',
  369: 'pls',
  371: 'tCNT',
  385: 'lisinski',
  400: 'hpn',
  401: 'ozo_tst',
  411: 'pepe',
  416: 'SX',
  418: 'latestnet',
  420: 'ogor',
  424: 'PGN',
  427: 'zeeth',
  443: 'obs-testnet',
  444: 'synapse-sepolia',
  456: 'arzio',
  462: 'tarea',
  499: 'rupx',
  500: 'Camino',
  501: 'Columbus',
  512: 'aac',
  513: 'aact',
  516: 'gz-mainnet',
  520: 'xt',
  529: 'fire',
  530: 'FxCore',
  534: 'CNDL',
  542: 'PAW',
  555: 'CLASS',
  558: 'tao',
  568: 'dct',
  570: 'sys-rollux',
  588: 'metis-stardust',
  592: 'astr',
  595: 'maca',
  596: 'tkar',
  597: 'taca',
  599: 'metis-goerli',
  600: 'mesh-chain-testnet',
  601: 'PEER',
  614: 'glq',
  634: 'avocado',
  647: 'SX-Testnet',
  648: 'ace',
  666: 'pixie-chain-testnet',
  667: 'laos',
  668: 'junca',
  669: 'juncat',
  686: 'kar',
  700: 'SNS',
  707: 'bcs',
  708: 'tbcs',
  710: 'fury',
  719: 'shibarium',
  721: 'LYC',
  740: 'tcanto',
  741: 'vsct',
  742: 'SPAY',
  766: 'qom',
  776: 'opc',
  777: 'cth',
  786: 'maal',
  787: 'aca',
  788: 'taero',
  789: 'peth',
  800: 'LUCID',
  803: 'haic',
  808: 'PFTEST',
  813: 'meer',
  818: 'BOC',
  820: 'clo',
  821: 'tclo',
  841: 'tara',
  842: 'taratest',
  859: 'zeethdev',
  868: 'FSCMainnet',
  876: 'BNKEN',
  877: 'DXT',
  880: 'ambros',
  888: 'wan',
  900: 'gar-test-s0',
  901: 'gar-test-s1',
  902: 'gar-test-s2',
  903: 'gar-test-s3',
  909: 'PF',
  910: 'DBONE',
  917: 'tfire',
  919: 'modesep',
  927: 'ydk',
  940: 'tpls',
  941: 't2bpls',
  942: 't3pls',
  943: 't4pls',
  956: 'munode',
  963: 'btc20',
  970: 'ccn',
  971: 'Huygens',
  972: 'Ascraeus',
  977: 'yeti',
  980: 'top_evm',
  985: 'memochain',
  989: 'top',
  990: 'ELm',
  997: '5ire',
  998: 'ln',
  999: 'twan',
  1000: 'gton',
  1001: 'Baobab',
  1002: 'kai',
  1003: 'tet',
  1004: 't-ekta',
  1007: 'tnew',
  1008: 'eun',
  1010: 'EVC',
  1012: 'new',
  1022: 'sku',
  1023: 'tclv',
  1024: 'clv',
  1028: 'tbtt',
  1030: 'cfx',
  1031: 'prx',
  1038: 'bronos-testnet',
  1039: 'bronos-mainnet',
  1071: 'shimmerevm-testnet-deprecated',
  1072: 'shimmerevm-testnet',
  1079: 'mintara-testnet',
  1080: 'mintara',
  1088: 'metis-andromeda',
  1089: 'humans',
  1099: 'moac',
  1101: 'zkevm',
  1107: 'tblxq',
  1108: 'blxq',
  1111: 'wemix',
  1112: 'twemix',
  1115: 'tcore',
  1116: 'core',
  1117: 'DOGSm',
  1130: 'DFI',
  1131: 'DFI-T',
  1133: 'changi',
  1138: 'ASARt',
  1139: 'MATH',
  1140: 'tMATH',
  1149: 'Plexchain',
  1170: 'auoc',
  1177: 'sht',
  1197: 'iora',
  1201: 'avis',
  1202: 'wtt',
  1213: 'popcat',
  1214: 'enter',
  1229: 'xzo',
  1230: 'UltronTestnet',
  1231: 'UtronMainnet',
  1234: 'step',
  1243: 'ARC',
  1244: 'TARC',
  1246: 'om',
  1252: 'CICT',
  1280: 'HO',
  1284: 'mbeam',
  1285: 'mriver',
  1286: 'mrock-old',
  1287: 'mbase',
  1288: 'mrock',
  1291: 'swtr',
  1294: 'Bobabeam',
  1297: 'Bobabase',
  1311: 'TDOS',
  1314: 'alyx',
  1319: 'aia',
  1320: 'aiatestnet',
  1337: 'geth',
  1338: 'ELST',
  1339: 'ELSM',
  1353: 'CIC',
  1369: 'zafic',
  1379: 'KLC',
  1388: 'ASAR',
  1392: 'mun',
  1402: 'zkevmtest',
  1422: 'testnet-zkEVM-mango-pre-audit-upgraded',
  1433: 'RIK',
  1440: 'LAS',
  1442: 'testnet-zkEVM-mango',
  1452: 'gil',
  1455: 'CTEX',
  1501: 'chainx',
  1506: 'Sherpax',
  1507: 'SherpaxTestnet',
  1515: 'beagle',
  1559: 'tenet',
  1618: 'cate',
  1620: 'ath',
  1657: 'bta',
  1662: 'Yuma',
  1663: 'Gobi',
  1688: 'LUDAN',
  1701: 'AnytypeChain',
  1707: 'TBSI',
  1708: 'tTBSI',
  1718: 'PCM',
  1773: 'TeaParty',
  1777: 'gauss',
  1804: 'kerleano',
  1807: 'rAna',
  1818: 'cube',
  1819: 'cubet',
  1856: 'tsf',
  1875: 'wbt',
  1881: 'gitshockchain',
  1890: 'lightlink_phoenix',
  1891: 'lightlink_pegasus',
  1898: 'boya',
  1907: 'bitci',
  1908: 'tbitci',
  1945: 'onus-testnet',
  1951: 'dchain-mainnet',
  1954: 'Dexilla',
  1967: 'mtc',
  1969: 'tscs',
  1970: 'scs',
  1971: 'atlr',
  1975: 'onus-mainnet',
  1984: 'euntest',
  1985: 'satoshie',
  1986: 'satoshie_testnet',
  1987: 'egem',
  1994: 'ekta',
  1995: 'edx',
  2000: 'dc',
  2001: 'milkAda',
  2002: 'milkALGO',
  2008: 'cloudwalk_testnet',
  2009: 'cloudwalk_mainnet',
  2016: 'NetZm',
  2018: 'pmint_dev',
  2019: 'pmint_test',
  2020: 'pmint',
  2021: 'edg',
  2022: 'edgt',
  2023: 'taycan-testnet',
  2025: 'rpg',
  2031: 'cfg',
  2032: 'ncfg',
  2037: 'kiwi',
  2038: 'shraptest',
  2043: 'otp',
  2044: 'Shrapnel',
  2047: 'stos-testnet',
  2048: 'stos-mainnet',
  2049: 'movo',
  2077: 'QKA',
  2088: 'air',
  2089: 'algl',
  2100: 'eco',
  2101: 'esp',
  2109: 'exn',
  2122: 'Metad',
  2124: 'MEU',
  2137: 'bigsb',
  2138: 'dfio-meta-test',
  2151: 'boa',
  2152: 'fra',
  2153: 'findora-testnet',
  2154: 'findora-forge',
  2199: 'msn',
  2202: 'ABNm',
  2203: 'BTC',
  2213: 'evanesco',
  2221: 'tkava',
  2222: 'kava',
  2223: 'VChain',
  2241: 'KRST',
  2300: 'bomb',
  2309: 'arevia',
  2323: 'sma',
  2330: 'alt',
  2332: 'smam',
  2357: 'deprecated-kroma-sepolia',
  2358: 'kroma-sepolia',
  2399: 'bombt',
  2400: 'TCGV',
  2415: 'xodex',
  2484: 'u2u_nebulas',
  2559: 'ktoc',
  2569: 'tpc',
  2606: 'pocrnet',
  2611: 'REDLC',
  2612: 'EZChain',
  2613: 'Fuji-EZChain',
  2625: 'twbt',
  2710: 'tmorph',
  2888: 'BobaGoerli',
  2999: 'bty',
  3000: 'cennz-r',
  3001: 'cennz-n',
  3003: 'cau',
  3011: '3ULL',
  3031: 'ORL',
  3068: 'bfc',
  3141: 'filecoin-hyperspace',
  3269: 'dubx',
  3270: 'testdubx',
  3306: 'debounce-devnet',
  3331: 'zcrbeach',
  3333: 'w3q-t',
  3334: 'w3q-g',
  3400: 'prb',
  3434: 'SCAIt',
  3500: 'prbtestnet',
  3501: 'jfin',
  3601: 'pando-mainnet',
  3602: 'pando-testnet',
  3636: 'BTCt',
  3637: 'BTCm',
  3666: 'jouleverse',
  3690: 'btx',
  3693: 'empire',
  3698: 'SPCt',
  3699: 'SPCm',
  3701: 'xplatest',
  3737: 'csb',
  3797: 'alv',
  3888: 'kalymainnet',
  3889: 'kalytestnet',
  3912: 'drac',
  3939: 'dost',
  3966: 'dyno',
  3967: 'tdyno',
  3999: 'ycc',
  4000: 'ozo',
  4001: 'PERIUM',
  4002: 'tftm',
  4051: 'BobaoperaTestnet',
  4061: 'Nahmii3Mainnet',
  4062: 'Nahmii3Testnet',
  4090: 'Oasis',
  4096: 'BNIt',
  4099: 'BNIm',
  4102: 'aioz-testnet',
  4139: 'humans_testnet',
  4141: 'TPBXt',
  4181: 'PHIv1',
  4201: 'lukso-testnet',
  4242: 'nexi',
  4328: 'BobaFujiTestnet',
  4337: 'beam',
  4444: 'html',
  4460: 'orderlyl2',
  4689: 'iotex-mainnet',
  4690: 'iotex-testnet',
  4759: 'TESTMEV',
  4777: 'TBXN',
  4918: 'txvm',
  4919: 'xvm',
  4999: 'BXN',
  5000: 'mantle',
  5001: 'mantle-testnet',
  5002: 'treasurenet',
  5005: 'tntest',
  5165: 'ftn',
  5177: 'tlc',
  5197: 'es',
  5234: 'hmnd',
  5290: '_old_fire',
  5315: 'UZMI',
  5353: 'ttrn',
  5522: 'VEX',
  5551: 'Nahmii',
  5553: 'NahmiiTestnet',
  5555: 'cverse',
  5611: 'obnbt',
  5616: 'ARCT',
  5678: 'TanssiCC',
  5700: 'tsys',
  5729: 'hik',
  5758: 'satst',
  5777: 'ggui',
  5851: 'OntologyTestnet',
  5869: 'rbd',
  6065: 'TRESTEST',
  6066: 'TRESMAIN',
  6102: 'cascadia',
  6118: 'UPTN-TEST',
  6119: 'UPTN',
  6502: 'Peerpay',
  6552: 'SRC-test',
  6565: 'fox',
  6626: 'pixie-chain',
  6688: 'iris',
  6789: 'STANDm',
  6969: 'tombchain',
  6999: 'psc',
  7000: 'zetachain-mainnet',
  7001: 'zetachain-athens',
  7027: 'ELLA',
  7070: 'planq',
  7171: 'bitrock',
  7331: 'kly',
  7332: 'EON',
  7341: 'shyft',
  7484: 'raba',
  7518: 'MEV',
  7575: 'tadil',
  7576: 'adil',
  7668: 'trn-mainnet',
  7672: 'trn-porcini',
  7700: 'canto',
  7701: 'TestnetCanto',
  7771: 'tbitrock',
  7777: 'RiseOfTheWarbotsTestnet',
  7878: 'tscas',
  7895: 'ard',
  7979: 'dos',
  8000: 'teleport',
  8001: 'teleport-testnet',
  8029: 'mdgl',
  12357: 'rei',
  7363: 'dnd',
  9052: 'acrechain',
  8080: 'Liberty10',
  8081: 'Liberty20',
  8082: 'Sphinx10',
  8086: 'BitEth',
  8098: 'StreamuX',
  8131: 'meertest',
  8132: 'meermix',
  8133: 'meerpriv',
  8134: 'amana',
  8135: 'flana',
  8136: 'mizana',
  8181: 'tBOC',
  8217: 'Cypress',
  8272: 'BTON',
  8285: 'Kortho',
  8387: 'fuck',
  8453: 'base',
  8654: 'toki',
  8655: 'toki-testnet',
  8723: 'olo',
  8724: 'tolo',
  8738: 'alph',
  8768: 'tmy',
  8848: 'maro',
  8880: 'unq',
  8881: 'qtz',
  8882: 'opl',
  8883: 'sph',
  8888: 'XANAChain',
  8889: 'vsc',
  8898: 'mmt',
  8899: 'jbc',
  8989: 'gmmt',
  8995: 'berg',
  9000: 'evmos-testnet',
  9001: 'evmos',
  9012: 'brb',
  9100: 'GENEC',
  9170: '_old_tfire',
  9223: 'COF',
  9339: 'DOGSt',
  9527: 'trpg',
  9528: 'QETTest',
  9559: 'testneon',
  9700: 'MainnetDev',
  9728: 'BobaBnbTestnet',
  9768: 'NetZt',
  9779: 'pn',
  9790: 'carbon',
  9792: 'carbon-testnet',
  9818: 'tIMP',
  9819: 'IMP',
  9977: 'tMIND',
  9990: 'AGNG',
  9996: 'MIND',
  9997: 'alt-testnet',
  9999: 'myn',
  10000: 'smartbch',
  10001: 'smartbchtest',
  10024: 'gon',
  10081: 'joct',
  10086: 'SJ',
  10101: 'GEN',
  10200: 'chi',
  10201: 'PWR',
  10243: 'aa',
  10248: '0xt',
  10395: 'TWLC',
  10507: 'Jade',
  10508: 'Snow',
  10823: 'CCP',
  10946: 'quadrans',
  10947: 'quadranstestnet',
  11110: 'astra',
  11111: 'WAGMI',
  11115: 'astra-testnet',
  11119: 'hbit',
  11235: 'ISLM',
  11437: 'shyftt',
  11612: 'SRDXt',
  11888: 'SAN',
  11891: 'Arianee',
  12009: 'sats',
  12051: 'tZERO',
  12052: 'ZERO',
  12123: 'BRC',
  12306: 'fibo',
  12321: 'blgchain',
  12345: 'steptest',
  12611: 'astrzk',
  12715: 'tRIK',
  12890: 'tqnet',
  13000: 'SPS',
  13308: 'Credit',
  13337: 'beam-testnet',
  13381: 'Phoenix',
  13812: 'sus',
  14000: 'SPS-Test',
  14853: 'hmnd-t5',
  15551: 'loop',
  15555: 'TrustTestnet',
  15557: 'eos-testnet',
  16000: 'mtt',
  16001: 'mtttest',
  16507: 'Genesys',
  16688: 'nyancat',
  16718: 'airdao',
  16888: 'tivar',
  17000: 'holesky',
  17171: 'G8Cm',
  17180: 'PCT',
  17777: 'eos',
  18000: 'ZKST',
  18122: 'STN',
  18159: 'pom',
  18181: 'G8Ct',
  18686: 'MXCzkEVM',
  19011: 'HMV',
  19845: 'btcix',
  20001: 'Camelark',
  20729: 'CLOTestnet',
  20736: 'p12',
  21337: 'cennz-a',
  21816: 'omc',
  22023: 'SFL',
  22040: 'airdao-test',
  22222: 'NAUTCHAIN',
  22776: 'map',
  23006: 'ABNt',
  23118: 'opside',
  23294: 'sapphire',
  23295: 'sapphire-testnet',
  24484: 'web',
  24734: 'mintme',
  25888: 'GOLDT',
  25925: 'bkct',
  26026: 'frm',
  26600: 'HTZ',
  26863: 'OAC',
  28528: 'obgor',
  30067: 'Piece',
  30103: 'ceri',
  31102: 'esn',
  31223: 'CLDTX',
  31224: 'CLD',
  31337: 'got',
  31415: 'filecoin-wallaby',
  32520: 'Brise',
  32659: 'fsn',
  32769: 'zil',
  32990: 'zil-isolated-server',
  33101: 'zil-testnet',
  33333: 'avs',
  33385: 'zil-devnet',
  33469: 'zq2-devnet',
  35011: 'j2o',
  35441: 'q',
  35443: 'q-testnet',
  38400: 'cmrpg',
  38401: 'ttrpg',
  39797: 'nrg',
  39815: 'oho',
  41500: 'ox-beta',
  42069: 'PC',
  42161: 'arb1',
  42170: 'arb-nova',
  42220: 'celo',
  42261: 'emerald-testnet',
  42262: 'emerald',
  42801: 'GST',
  42888: 'keth',
  43110: 'avaeth',
  43113: 'Fuji',
  43114: 'avax',
  43288: 'bobaavax',
  44444: 'FREN',
  44787: 'ALFA',
  45000: 'AutobahnNetwork',
  46688: 'tfsn',
  47805: 'REI',
  49049: 'floripa',
  49088: 'tbfc',
  49797: 'tnrg',
  50001: 'LOE',
  50021: 'tgton',
  51178: 'Opside-Testnet',
  51712: 'SRDXm',
  53935: 'DFK',
  54211: 'ISLMT',
  54321: 'ToronetTestnet',
  55004: 'teth',
  55555: 'reichain',
  55556: 'trei',
  56288: 'BobaBnb',
  56789: 'VELO',
  57000: 'tsys-rollux',
  58008: 'sepPGN',
  59140: 'linea-testnet',
  59144: 'linea',
  60000: 'TKM-test0',
  60001: 'TKM-test1',
  60002: 'TKM-test2',
  60103: 'TKM-test103',
  61800: 'aium-dev',
  61803: 'Etica',
  61916: 'DoKEN',
  62320: 'BKLV',
  62621: 'mtv',
  63000: 'ecs',
  63001: 'ecs-testnet',
  65450: 'SRC',
  67390: 'mcl',
  67588: 'Cosmic',
  69420: 'cndr',
  70000: 'TKM0',
  70001: 'TKM1',
  70002: 'TKM2',
  70103: 'TKM103',
  71111: 'GuapX',
  71393: 'ckb',
  71401: 'gw-testnet-v1',
  71402: 'gw-mainnet-v1',
  73799: 'vt',
  73927: 'mvm',
  75000: 'resin',
  77238: 'fnc',
  77612: 'vscm',
  77777: 'Toronet',
  78110: 'firenze',
  78281: 'dfly',
  78430: 'amplify',
  78431: 'bulletin',
  78432: 'conduit',
  79879: 'STANDt',
  80001: 'maticmum',
  81341: 'amanatest',
  81342: 'amanamix',
  81343: 'amanapriv',
  81351: 'flanatest',
  81352: 'flanamix',
  81353: 'flanapriv',
  81361: 'mizanatest',
  81362: 'mizanamix',
  81363: 'mizanapriv',
  81720: 'qnet',
  84531: 'basegor',
  84886: 'Aerie',
  85449: 'Cyber',
  88002: 'NAUTTest',
  88880: 'chz',
  88888: 'ivar',
  90210: 'bvhl',
  91002: 'NAUT',
  92001: 'lambda-testnet',
  96970: 'mantis',
  97288: 'BobaBnbOld',
  99099: 'ELt',
  99998: 'usctest',
  99999: 'usc',
  100000: 'qkc-r',
  100001: 'qkc-s0',
  100002: 'qkc-s1',
  100003: 'qkc-s2',
  100004: 'qkc-s3',
  100005: 'qkc-s4',
  100006: 'qkc-s5',
  100007: 'qkc-s6',
  100008: 'qkc-s7',
  100009: 'vechain',
  100010: 'vechain-testnet',
  100100: 'chi1',
  101010: 'SVRNt',
  103090: 'CRFI',
  108801: 'bro',
  110000: 'qkc-d-r',
  110001: 'qkc-d-s0',
  110002: 'qkc-d-s1',
  110003: 'qkc-d-s2',
  110004: 'qkc-d-s3',
  110005: 'qkc-d-s4',
  110006: 'qkc-d-s5',
  110007: 'qkc-d-s6',
  110008: 'qkc-d-s7',
  111000: 'testsbr',
  111111: 'sbr',
  112358: 'metao',
  123456: 'dadil',
  131419: 'ETND',
  142857: 'ICPlaza',
  167004: 'taiko-a2',
  167005: 'taiko-l2',
  167006: 'taiko-l3',
  167007: 'tko-jolnir',
  188881: 'condor',
  200101: 'milkTAda',
  200202: 'milkTAlgo',
  200625: 'aka',
  201018: 'alaya',
  201030: 'alayadev',
  201804: 'myth',
  202020: 'tDSC',
  202624: 'twl-jellie',
  210425: 'platon',
  220315: 'mas',
  221230: 'reap',
  221231: 'reap-testnet',
  224168: 'TAFECO',
  230315: 'hsktest',
  234666: 'hym',
  246529: 'ats',
  246785: 'atstau',
  247253: 'saakuru-testnet',
  256256: 'cmp-mainnet',
  266256: 'gz-testnet',
  271271: 'EGONt',
  281121: 'SoChain',
  314159: 'filecoin-calibration',
  330844: 'tc',
  333331: 'avst',
  333666: 'oonetest',
  333777: 'oonedev',
  333888: 'sparta',
  333999: 'olympus',
  355113: 'Bitfinity',
  373737: 'hap-testnet',
  381931: 'metal',
  381932: 'Tahoe',
  404040: 'TPBXm',
  420420: 'KEK',
  420666: 'tKEK',
  420692: 'alterium',
  421611: 'arb-rinkeby',
  421613: 'arb-goerli',
  421614: 'arb-sep',
  424242: 'fastexTestnet',
  431140: 'markr-go',
  432201: 'dexalot-testnet',
  432204: 'dexalot',
  444900: 'wlkt',
  471100: 'psep',
  474142: 'oc',
  512512: 'cmp',
  513100: 'ethf',
  534351: 'scr-sepolia',
  534352: 'scr',
  534353: 'scr-alpha',
  534354: 'scr-prealpha',
  534849: 'shi',
  535037: 'BESC',
  622277: 'rth',
  641230: 'BRNKC',
  651940: 'ALL',
  666666: 'vpioneer',
  751230: 'BRNKCTEST',
  761412: 'Miexs',
  776877: 'mdlrm',
  800001: 'octa',
  827431: 'CURVEm',
  846000: 'bloqs4good',
  888888: 'vision',
  900000: 'psc-s0',
  910000: 'psc-t-s0',
  920000: 'psc-d-s0',
  920001: 'psc-d-s1',
  923018: 'tFNCY',
  955305: 'elv',
  1261120: 'azktn',
  1313114: 'etho',
  1313500: 'xero',
  1337702: 'kintsugi',
  1337802: 'kiln',
  1337803: 'zhejiang',
  2021398: 'dbk',
  2099156: 'plian-mainnet',
  2203181: 'platondev',
  2206132: 'platondev2',
  3141592: 'filecoin-butterfly',
  3441005: 'mantaTestnet',
  4000003: 'alt-zerogas',
  4281033: 'worldscal',
  5167003: 'MXC',
  5555555: 'imversed',
  5555558: 'imversed-testnet',
  7225878: 'saakuru',
  7355310: 'vsl',
  7668378: 'tqom',
  7762959: 'music',
  7777777: 'zora',
  8007736: 'plian-mainnet-l2',
  8794598: 'hap',
  8888881: 'quarix-testnet',
  8888888: 'quarix',
  10067275: 'plian-testnet-l2',
  10101010: 'SVRNm',
  11155111: 'sep',
  13371337: 'tpep',
  14288640: 'anduschain-mainnet',
  16658437: 'plian-testnet',
  18289463: 'ilt',
  20180430: 'spectrum',
  20181205: 'qki',
  20201022: 'pg',
  22052002: 'xlon',
  27082017: 'exlvolta',
  27082022: 'exl',
  28945486: 'auxi',
  29032022: 'fla',
  31415926: 'filecoin-local',
  35855456: 'JOYS',
  43214913: 'mais',
  61717561: 'aqua',
  65010000: 'bakerloo-0',
  65100000: 'piccadilly-0',
  88888888: 'team',
  99415706: 'TOYS',
  192837465: 'GTH',
  222000222: 'kanazawa',
  245022926: 'neonevm-devnet',
  245022934: 'neonevm-mainnet',
  245022940: 'neonevm-testnet',
  278611351: 'razor',
  311752642: 'oneledger',
  333000333: 'meld',
  344106930: 'calypso-testnet',
  356256156: 'tGTH',
  486217935: 'dGTH',
  503129905: 'nebula-staging',
  1122334455: 'ipos',
  1146703430: 'cyb',
  1273227453: 'human-mainnet',
  1313161554: 'aurora',
  1313161555: 'aurora-testnet',
  1313161556: 'aurora-betanet',
  1351057110: 'chaos-tenet',
  1380996178: 'rptr',
  1482601649: 'nebula-mainnet',
  1564830818: 'calypso-mainnet',
  1666600000: 'hmy-s0',
  1666600001: 'hmy-s1',
  1666600002: 'hmy-s2',
  1666600003: 'hmy-s3',
  1666700000: 'hmy-b-s0',
  1666700001: 'hmy-b-s1',
  1666900000: 'hmy-ps-s0',
  1666900001: 'hmy-ps-s1',
  2021121117: 'hop',
  2046399126: 'europa',
  2863311531: 'a8',
  3125659152: 'pirl',
  4216137055: 'frankenstein',
  11297108099: 'tpalm',
  11297108109: 'palm',
  111222333444: 'alphabet',
  197710212030: 'ntt',
  197710212031: 'ntt-haradev',
  383414847825: 'zeniq',
  666301171999: 'ipdc',
  6022140761023: 'mole',
  868455272153094: 'gw-testnet-v1-deprecated'
} as const;

export const EXPLORER_API_URLS = {
  '1': 'https://api.etherscan.io/api',
  '5': 'https://api-goerli.etherscan.io/api',
  '10': 'https://api-optimistic.etherscan.io/api',
  '100': 'https://gnosis.blockscout.com/api',
  '73799': 'https://volta-explorer.energyweb.org/api',
  '246': 'https://explorer.energyweb.org/api',
  '137': 'https://api.polygonscan.com/api',
  '56': 'https://api.bscscan.com/api',
  '42161': 'https://api.arbiscan.io/api',
  '8453' : 'https://api.basescan.org/api',
  // '1116': Add 'https://openapi.coredao.org/api' if API key requirement is removed
  '11155111': 'https://api-sepolia.etherscan.io/api',
} as const;

export const GNOSIS_SAFE_TRANSACTION_API_URLS = {
  '1': 'https://safe-transaction-mainnet.safe.global/api',
  '5': 'https://safe-transaction-goerli.safe.global/api',
  '10': 'https://safe-transaction-optimism.safe.global/api',
  '100': 'https://safe-transaction-gnosis-chain.safe.global/api',
  '8453': 'https://safe-transaction-base.safe.global/api',
  '73799': 'https://safe-transaction-volta.safe.global/api',
  '246': 'https://safe-transaction-ewc.safe.global/api',
  '137': 'https://safe-transaction-polygon.safe.global/api',
  '56': 'https://safe-transaction-bsc.safe.global/api',
  '42161': 'https://safe-transaction-arbitrum.safe.global/api',
  '1116': 'https://safetx.coredao.org/api',
  '11155111': 'https://safe-transaction-sepolia.safe.global/api',
} as const;

export const SAFE_APP_URLS = {
  '1': 'https://app.safe.global/apps/open',
  '5': 'https://app.safe.global/apps/open',
  '100': 'https://app.safe.global/apps/open',
  '73799': 'https://app.safe.global/apps/open',
  '246': 'https://app.safe.global/apps/open',
  '137': 'https://app.safe.global/apps/open',
  '56': 'https://app.safe.global/apps/open',
  '42161': 'https://app.safe.global/apps/open',
  '1116': 'https://safe.coredao.org/apps/open',
  '8453': 'https://app.safe.global/apps/open',
  '11155111': 'https://app.safe.global/apps/open',
} as const;

// ABIs
export const OPTIMISTIC_GOVERNOR_ABI = [
  'constructor(address _finder, address _owner, address _collateral, uint256 _bondAmount, string _rules, bytes32 _identifier, uint64 _liveness)',
  'error NotIERC165Compliant(address guard_)',
  'event AvatarSet(address indexed previousAvatar, address indexed newAvatar)',
  'event ChangedGuard(address guard)',
  'event Initialized(uint8 version)',
  'event OptimisticGovernorDeployed(address indexed owner, address indexed avatar, address target)',
  'event OptimisticOracleChanged(address indexed newOptimisticOracleV3)',
  'event OwnershipTransferred(address indexed previousOwner, address indexed newOwner)',
  'event ProposalDeleted(bytes32 indexed proposalHash, bytes32 indexed assertionId)',
  'event ProposalExecuted(bytes32 indexed proposalHash, bytes32 indexed assertionId)',
  'event SetCollateralAndBond(address indexed collateral, uint256 indexed bondAmount)',
  'event SetEscalationManager(address indexed escalationManager)',
  'event SetIdentifier(bytes32 indexed identifier)',
  'event SetLiveness(uint64 indexed liveness)',
  'event SetRules(string rules)',
  'event TargetSet(address indexed previousTarget, address indexed newTarget)',
  'event TransactionExecuted(bytes32 indexed proposalHash, bytes32 indexed assertionId, uint256 indexed transactionIndex)',
  'event TransactionsProposed(address indexed proposer, uint256 indexed proposalTime, bytes32 indexed assertionId, tuple(tuple(address to, uint8 operation, uint256 value, bytes data)[] transactions, uint256 requestTime) proposal, bytes32 proposalHash, bytes explanation, string rules, uint256 challengeWindowEnds)',
  'function EXPLANATION_KEY() view returns (bytes)',
  'function PROPOSAL_HASH_KEY() view returns (bytes)',
  'function RULES_KEY() view returns (bytes)',
  'function assertionDisputedCallback(bytes32 assertionId)',
  'function assertionIds(bytes32) view returns (bytes32)',
  'function assertionResolvedCallback(bytes32 assertionId, bool assertedTruthfully)',
  'function avatar() view returns (address)',
  'function bondAmount() view returns (uint256)',
  'function collateral() view returns (address)',
  'function deleteProposalOnUpgrade(bytes32 proposalHash)',
  'function escalationManager() view returns (address)',
  'function executeProposal(tuple(address to, uint8 operation, uint256 value, bytes data)[] transactions)',
  'function finder() view returns (address)',
  'function getCurrentTime() view returns (uint256)',
  'function getGuard() view returns (address _guard)',
  'function getProposalBond() view returns (uint256)',
  'function guard() view returns (address)',
  'function identifier() view returns (bytes32)',
  'function liveness() view returns (uint64)',
  'function optimisticOracleV3() view returns (address)',
  'function owner() view returns (address)',
  'function proposalHashes(bytes32) view returns (bytes32)',
  'function proposeTransactions(tuple(address to, uint8 operation, uint256 value, bytes data)[] transactions, bytes explanation)',
  'function renounceOwnership()',
  'function rules() view returns (string)',
  'function setAvatar(address _avatar)',
  'function setCollateralAndBond(address _collateral, uint256 _bondAmount)',
  'function setEscalationManager(address _escalationManager)',
  'function setGuard(address _guard)',
  'function setIdentifier(bytes32 _identifier)',
  'function setLiveness(uint64 _liveness)',
  'function setRules(string _rules)',
  'function setTarget(address _target)',
  'function setUp(bytes initializeParams)',
  'function sync()',
  'function target() view returns (address)',
  'function transferOwnership(address newOwner)'
] as const;

export const OPTIMISTIC_ORACLE_V3_ABI = [
  'constructor(address _finder, address _defaultCurrency, uint64 _defaultLiveness)',
  'event AdminPropertiesSet(address defaultCurrency, uint64 defaultLiveness, uint256 burnedBondPercentage)',
  'event AssertionDisputed(bytes32 indexed assertionId, address indexed caller, address indexed disputer)',
  'event AssertionMade(bytes32 indexed assertionId, bytes32 domainId, bytes claim, address indexed asserter, address callbackRecipient, address escalationManager, address caller, uint64 expirationTime, address currency, uint256 bond, bytes32 indexed identifier)',
  'event AssertionSettled(bytes32 indexed assertionId, address indexed bondRecipient, bool disputed, bool settlementResolution, address settleCaller)',
  'event OwnershipTransferred(address indexed previousOwner, address indexed newOwner)',
  'function assertTruth(bytes claim, address asserter, address callbackRecipient, address escalationManager, uint64 liveness, address currency, uint256 bond, bytes32 identifier, bytes32 domainId) returns (bytes32 assertionId)',
  'function assertTruthWithDefaults(bytes claim, address asserter) returns (bytes32)',
  'function assertions(bytes32) view returns (tuple(bool arbitrateViaEscalationManager, bool discardOracle, bool validateDisputers, address assertingCaller, address escalationManager) escalationManagerSettings, address asserter, uint64 assertionTime, bool settled, address currency, uint64 expirationTime, bool settlementResolution, bytes32 domainId, bytes32 identifier, uint256 bond, address callbackRecipient, address disputer)',
  'function burnedBondPercentage() view returns (uint256)',
  'function cachedCurrencies(address) view returns (bool isWhitelisted, uint256 finalFee)',
  'function cachedIdentifiers(bytes32) view returns (bool)',
  'function cachedOracle() view returns (address)',
  'function defaultCurrency() view returns (address)',
  'function defaultIdentifier() view returns (bytes32)',
  'function defaultLiveness() view returns (uint64)',
  'function disputeAssertion(bytes32 assertionId, address disputer)',
  'function finder() view returns (address)',
  'function getAssertion(bytes32 assertionId) view returns (tuple(tuple(bool arbitrateViaEscalationManager, bool discardOracle, bool validateDisputers, address assertingCaller, address escalationManager) escalationManagerSettings, address asserter, uint64 assertionTime, bool settled, address currency, uint64 expirationTime, bool settlementResolution, bytes32 domainId, bytes32 identifier, uint256 bond, address callbackRecipient, address disputer))',
  'function getAssertionResult(bytes32 assertionId) view returns (bool)',
  'function getCurrentTime() view returns (uint256)',
  'function getMinimumBond(address currency) view returns (uint256)',
  'function multicall(bytes[] data) returns (bytes[] results)',
  'function numericalTrue() view returns (int256)',
  'function owner() view returns (address)',
  'function renounceOwnership()',
  'function setAdminProperties(address _defaultCurrency, uint64 _defaultLiveness, uint256 _burnedBondPercentage)',
  'function settleAndGetAssertionResult(bytes32 assertionId) returns (bool)',
  'function settleAssertion(bytes32 assertionId)',
  'function stampAssertion(bytes32 assertionId) view returns (bytes)',
  'function syncUmaParams(bytes32 identifier, address currency)',
  'function transferOwnership(address newOwner)'
] as const;

export const VOTING_ABI = [
  'constructor(uint128 _emissionRate, uint64 _unstakeCoolDown, uint64 _phaseLength, uint32 _maxRolls, uint32 _maxRequestsPerRound, uint128 _gat, uint64 _spat, address _votingToken, address _finder, address _slashingLibrary, address _previousVotingContract)',
  'event DelegateSet(address indexed delegator, address indexed delegate)',
  'event DelegatorSet(address indexed delegate, address indexed delegator)',
  'event EncryptedVote(address indexed caller, uint32 indexed roundId, bytes32 indexed identifier, uint256 time, bytes ancillaryData, bytes encryptedVote)',
  'event ExecutedUnstake(address indexed voter, uint128 tokensSent, uint128 voterStake)',
  'event GatAndSpatChanged(uint128 newGat, uint64 newSpat)',
  'event MaxRequestsPerRoundChanged(uint32 newMaxRequestsPerRound)',
  'event MaxRollsChanged(uint32 newMaxRolls)',
  'event OwnershipTransferred(address indexed previousOwner, address indexed newOwner)',
  'event RequestAdded(address indexed requester, uint32 indexed roundId, bytes32 indexed identifier, uint256 time, bytes ancillaryData, bool isGovernance)',
  'event RequestDeleted(bytes32 indexed identifier, uint256 indexed time, bytes ancillaryData, uint32 rollCount)',
  'event RequestResolved(uint32 indexed roundId, uint256 indexed resolvedPriceRequestIndex, bytes32 indexed identifier, uint256 time, bytes ancillaryData, int256 price)',
  'event RequestRolled(bytes32 indexed identifier, uint256 indexed time, bytes ancillaryData, uint32 rollCount)',
  'event RequestedUnstake(address indexed voter, uint128 amount, uint64 unstakeTime, uint128 voterStake)',
  'event SetNewEmissionRate(uint128 newEmissionRate)',
  'event SetNewUnstakeCoolDown(uint64 newUnstakeCoolDown)',
  'event SlashingLibraryChanged(address newAddress)',
  'event Staked(address indexed voter, address indexed from, uint128 amount, uint128 voterStake, uint128 voterPendingUnstake, uint128 cumulativeStake)',
  'event UpdatedReward(address indexed voter, uint128 newReward, uint64 lastUpdateTime)',
  'event VoteCommitted(address indexed voter, address indexed caller, uint32 roundId, bytes32 indexed identifier, uint256 time, bytes ancillaryData)',
  'event VoteRevealed(address indexed voter, address indexed caller, uint32 roundId, bytes32 indexed identifier, uint256 time, bytes ancillaryData, int256 price, uint128 numTokens)',
  'event VoterSlashApplied(address indexed voter, int128 slashedTokens, uint128 postStake)',
  'event VoterSlashed(address indexed voter, uint256 indexed requestIndex, int128 slashedTokens)',
  'event VotingContractMigrated(address newAddress)',
  'event WithdrawnRewards(address indexed voter, address indexed delegate, uint128 tokensWithdrawn)',
  'function ANCILLARY_BYTES_LIMIT() view returns (uint256)',
  'function UINT64_MAX() view returns (uint64)',
  'function commitAndEmitEncryptedVote(bytes32 identifier, uint256 time, bytes ancillaryData, bytes32 hash, bytes encryptedVote)',
  'function commitVote(bytes32 identifier, uint256 time, bytes ancillaryData, bytes32 hash)',
  'function cumulativeStake() view returns (uint128)',
  'function currentActiveRequests() view returns (bool)',
  'function delegateToStaker(address) view returns (address)',
  'function emissionRate() view returns (uint128)',
  'function executeUnstake()',
  'function finder() view returns (address)',
  'function gat() view returns (uint128)',
  'function getCurrentRoundId() view returns (uint32)',
  'function getCurrentTime() view returns (uint256)',
  'function getNumberOfPriceRequests() view returns (uint256 numberPendingPriceRequests, uint256 numberResolvedPriceRequests)',
  'function getNumberOfPriceRequestsPostUpdate() returns (uint256 numberPendingPriceRequests, uint256 numberResolvedPriceRequests)',
  'function getPendingRequests() view returns (tuple(uint32 lastVotingRound, bool isGovernance, uint64 time, uint32 rollCount, bytes32 identifier, bytes ancillaryData)[])',
  'function getPrice(bytes32 identifier, uint256 time, bytes ancillaryData) view returns (int256)',
  'function getPrice(bytes32 identifier, uint256 time) view returns (int256)',
  'function getPriceRequestStatuses(tuple(bytes32 identifier, uint256 time, bytes ancillaryData)[] requests) view returns (tuple(uint8 status, uint32 lastVotingRound)[])',
  'function getRoundEndTime(uint256 roundId) view returns (uint256)',
  'function getRoundIdToVoteOnRequest(uint32 targetRoundId) view returns (uint32)',
  'function getVotePhase() view returns (uint8)',
  'function getVoterFromDelegate(address caller) view returns (address)',
  'function getVoterParticipation(uint256 requestIndex, uint32 lastVotingRound, address voter) view returns (uint8)',
  'function getVoterPendingStake(address voter, uint32 roundId) view returns (uint128)',
  'function getVoterStakePostUpdate(address voter) returns (uint128)',
  'function hasPrice(bytes32 identifier, uint256 time) view returns (bool)',
  'function hasPrice(bytes32 identifier, uint256 time, bytes ancillaryData) view returns (bool)',
  'function lastRoundIdProcessed() view returns (uint32)',
  'function lastUpdateTime() view returns (uint64)',
  'function maxRequestsPerRound() view returns (uint32)',
  'function maxRolls() view returns (uint32)',
  'function migratedAddress() view returns (address)',
  'function multicall(bytes[] data) returns (bytes[] results)',
  'function nextPendingIndexToProcess() view returns (uint64)',
  'function outstandingRewards(address voter) view returns (uint256)',
  'function owner() view returns (address)',
  'function pendingPriceRequestsIds(uint256) view returns (bytes32)',
  'function previousVotingContract() view returns (address)',
  'function priceRequests(bytes32) view returns (uint32 lastVotingRound, bool isGovernance, uint64 time, uint32 rollCount, bytes32 identifier, bytes ancillaryData)',
  'function processResolvablePriceRequests()',
  'function processResolvablePriceRequestsRange(uint64 maxTraversals)',
  'function renounceOwnership()',
  'function requestGovernanceAction(bytes32 identifier, uint256 time, bytes ancillaryData)',
  'function requestPrice(bytes32 identifier, uint256 time, bytes ancillaryData)',
  'function requestPrice(bytes32 identifier, uint256 time)',
  'function requestSlashingTrackers(uint256 requestIndex) view returns (tuple(uint256 wrongVoteSlashPerToken, uint256 noVoteSlashPerToken, uint256 totalSlashed, uint256 totalCorrectVotes, uint32 lastVotingRound))',
  'function requestUnstake(uint128 amount)',
  'function resolvedPriceRequestIds(uint256) view returns (bytes32)',
  'function retrieveRewardsOnMigratedVotingContract(address voter, uint256 roundId, tuple(bytes32 identifier, uint256 time, bytes ancillaryData)[] toRetrieve) returns (uint256)',
  'function revealVote(bytes32 identifier, uint256 time, int256 price, bytes ancillaryData, int256 salt)',
  'function rewardPerToken() view returns (uint256)',
  'function rewardPerTokenStored() view returns (uint128)',
  'function rounds(uint256) view returns (address slashingLibrary, uint128 minParticipationRequirement, uint128 minAgreementRequirement, uint128 cumulativeStakeAtRound, uint32 numberOfRequestsToVote)',
  'function setDelegate(address delegate)',
  'function setDelegator(address delegator)',
  'function setEmissionRate(uint128 newEmissionRate)',
  'function setGatAndSpat(uint128 newGat, uint64 newSpat)',
  'function setMaxRequestPerRound(uint32 newMaxRequestsPerRound)',
  'function setMaxRolls(uint32 newMaxRolls)',
  'function setMigrated(address newVotingAddress)',
  'function setSlashingLibrary(address _newSlashingLibrary)',
  'function setUnstakeCoolDown(uint64 newUnstakeCoolDown)',
  'function slashingLibrary() view returns (address)',
  'function spat() view returns (uint64)',
  'function stake(uint128 amount)',
  'function stakeTo(address recipient, uint128 amount)',
  'function transferOwnership(address newOwner)',
  'function unstakeCoolDown() view returns (uint64)',
  'function updateTrackers(address voter)',
  'function updateTrackersRange(address voter, uint64 maxTraversals)',
  'function voteTiming() view returns (uint256 phaseLength)',
  'function voterStakes(address) view returns (uint128 stake, uint128 pendingUnstake, uint128 rewardsPaidPerToken, uint128 outstandingRewards, int128 unappliedSlash, uint64 nextIndexToProcess, uint64 unstakeTime, address delegate)',
  'function votingToken() view returns (address)',
  'function withdrawAndRestake() returns (uint128)',
  'function withdrawRewards() returns (uint128)'
] as const;

export const UMA_FINDER_ABI = [
  'event InterfaceImplementationChanged(bytes32 indexed interfaceName, address indexed newImplementationAddress)',
  'event OwnershipTransferred(address indexed previousOwner, address indexed newOwner)',
  'function changeImplementationAddress(bytes32 interfaceName, address implementationAddress)',
  'function getImplementationAddress(bytes32 interfaceName) view returns (address)',
  'function interfacesImplemented(bytes32) view returns (address)',
  'function owner() view returns (address)',
  'function renounceOwnership()',
  'function transferOwnership(address newOwner)'
] as const;

export const ERC20_ABI = [
  //Read functions
  'function balanceOf(address account) view returns (uint256)',
  'function decimals() view returns (uint32)',
  'function symbol() view returns (string)',
  'function allowance(address owner, address spender) external view returns (uint256)',

  // Write functions
  'function approve(address spender, uint256 value) external returns (bool)',
  'function transfer(address recipient, uint256 amount) public virtual override returns (bool)'
] as const;

export const ERC721_ABI = [
  'function safeTransferFrom(address _from, address _to, uint256 _tokenId) external payable'
] as const;

// to potentially cut down on event ranges we query, hard code some deploy blocks for contracts
export type ContractData = {
  network: string;
  name: string;
  address?: string;
  deployBlock?: number;
  subgraph?: string;
};
// contract addresses pulled from https://github.com/UMAprotocol/protocol/tree/master/packages/core/networks
export const contractData = [
  {
    // mainnet
    network: '1',
    name: 'OptimisticOracleV3',
    address: '0xfb55F43fB9F48F63f9269DB7Dde3BbBe1ebDC0dE',
    subgraph:
      'https://subgrapher.snapshot.org/subgraph/arbitrum/Bm3ytsa1YvcyFJahdfQQgscFQVCcMvoXujzkd3Cz6aof',
    deployBlock: 16636058
  },
  {
    // goerli
    network: '5',
    name: 'OptimisticOracleV3',
    address: '0x9923D42eF695B5dd9911D05Ac944d4cAca3c4EAB',
    subgraph:
      'https://api.thegraph.com/subgraphs/name/md0x/goerli-optimistic-oracle-v3',
    deployBlock: 8497481
  },
  {
    // optimism
    network: '10',
    name: 'OptimisticOracleV3',
    address: '0x072819Bb43B50E7A251c64411e7aA362ce82803B',
    subgraph:
      'https://subgrapher.snapshot.org/subgraph/arbitrum/FyJQyV5TLNeowZrL6kLUTB9JNPyWQNCNXJoxJWGEtBcn',
    deployBlock: 74537234
  },
  {
    // gnosis
    network: '100',
    name: 'OptimisticOracleV3',
    address: '0x22A9AaAC9c3184f68C7B7C95b1300C4B1D2fB95C',
    subgraph:
      'https://subgrapher.snapshot.org/subgraph/arbitrum/9K2nctaB2rAh7Cgzx3wKtdHwWoEeEQ9AThGATak6Ngm9',
    deployBlock: 27087150
  },
  {
    // polygon
    network: '137',
    name: 'OptimisticOracleV3',
    address: '0x5953f2538F613E05bAED8A5AeFa8e6622467AD3D',
    subgraph:
      'https://subgrapher.snapshot.org/subgraph/arbitrum/7KWbDhUE5Eqcfn3LXQtLbCfJLkNucnhzJLpi2jKhqNuf',
    deployBlock: 39331673
  },
  {
    //arbitrum
    network: '42161',
    name: 'OptimisticOracleV3',
    address: '0xa6147867264374F324524E30C02C331cF28aa879',
    subgraph:
      'https://subgrapher.snapshot.org/subgraph/arbitrum/9wpkM5tHgJBHYTzKEKk4tK8a7q6MimfS9QnW7Japa8hW',
    deployBlock: 61236565
  },
  {
    // avalanche
    network: '43114',
    name: 'OptimisticOracleV3',
    address: '0xa4199d73ae206d49c966cF16c58436851f87d47F',
    subgraph:
      'https://subgrapher.snapshot.org/subgraph/arbitrum/3k8gzGzTMV2vDZAGBFM2q642SUyVbE31bAUL8SjFQkre',
    deployBlock: 27816737
  },
  {
    // core
    network: '1116',
    name: 'OptimisticOracleV3',
    address: '0xD84ACa67d683aF7702705141b3C7E57e4e5e7726',
    subgraph:
      'https://thegraph.coredao.org/subgraphs/name/umaprotocol/core-optimistic-oracle-v3',
    deployBlock: 11341063
  },
  {
    // base
    network: '8453',
    name: 'OptimisticOracleV3',
    address: '0x2aBf1Bd76655de80eDB3086114315Eec75AF500c',
    subgraph:
      'https://subgrapher.snapshot.org/subgraph/arbitrum/2Q4i8YgVZd6bAmLyDxXgrKPL2B6QwySiEUqbTyQ4vm4C',
    deployBlock: 12066343
  },
  {
    // sepolia
    network: '11155111',
    name: 'OptimisticOracleV3',
    address: '0xFd9e2642a170aDD10F53Ee14a93FcF2F31924944',
    subgraph:
      'https://subgrapher.snapshot.org/subgraph/arbitrum/78JbrMhcC9CVDZHDADvNcyhRrrccTJG4vCVBztyer1Xa',
    deployBlock: 5421195
  },
  {
    // mainnet
    network: '1',
    name: 'OptimisticGovernor',
    address: '0x28CeBFE94a03DbCA9d17143e9d2Bd1155DC26D5d',
    subgraph:
      'https://subgrapher.snapshot.org/subgraph/arbitrum/DQpwhiRSPQJEuc8y6ZBGsFfNpfwFQ8NjmjLmfv8kBkLu',
    deployBlock: 16890621
  },
  // Keep in mind, OG addresses are not the module addresses for each individual space, these addresses typically
  // are not used, but are here for reference.
  {
    //goerli
    network: '5',
    name: 'OptimisticGovernor',
    address: '0x07a7Be7AA4AaD42696A17e974486cb64A4daC47b',
    deployBlock: 8700589,
    subgraph:
      'https://api.thegraph.com/subgraphs/name/md0x/goerli-optimistic-governor'
  },
  {
    // optimism
    network: '10',
    name: 'OptimisticGovernor',
    address: '0x357fe84E438B3150d2F68AB9167bdb8f881f3b9A',
    deployBlock: 83168480,
    subgraph:
      'https://subgrapher.snapshot.org/subgraph/arbitrum/Fd5RvSfkajAJ8Mi9sPxFSMVPFf56SDivDQW3ocqTAW5'
  },
  {
    // gnosis
    network: '100',
    name: 'OptimisticGovernor',
    deployBlock: 27102135,
    subgraph:
      'https://subgrapher.snapshot.org/subgraph/arbitrum/RrkjZ6wTgLJkcjX68auzrEZHMRYwDx8kR5sFQQy4Phz'
  },
  {
    // polygon
    network: '137',
    name: 'OptimisticGovernor',
    address: '0x3Cc4b597E9c3f51288c6Cd0c087DC14c3FfdD966',
    deployBlock: 40677035,
    subgraph:
      'https://subgrapher.snapshot.org/subgraph/arbitrum/7L2JM14PnZgxGnRX7xaz54zWS6KVK6ZqVRCxEKJrJTDG'
  },
  {
    // arbitrum
    network: '42161',
    name: 'OptimisticGovernor',
    address: '0x30679ca4ea452d3df8a6c255a806e08810321763',
    deployBlock: 72850751,
    subgraph:
      'https://subgrapher.snapshot.org/subgraph/arbitrum/BfK867bnkQhnx1LspA99ypqiqxbAReQ92aZz66Ubv4tz'
  },
  {
    // avalanche
    network: '43114',
    name: 'OptimisticGovernor',
    address: '0xEF8b46765ae805537053C59f826C3aD61924Db45',
    deployBlock: 28050250,
    subgraph:
      'https://subgrapher.snapshot.org/subgraph/arbitrum/5F8875fmvtnv8Vv4aeedUcwNWjuxUg54aTHdapFuMJi3'
  },
  {
    // core
    network: '1116',
    name: 'OptimisticGovernor',
    address: '0x596Fd6A5A185c67aBD1c845b39f593fBA9C233aa',
    deployBlock: 11341122,
    subgraph:
    'https://thegraph.coredao.org/subgraphs/name/umaprotocol/core-optimistic-governor'
  },
  {
    // base
    network: '8453',
    name: 'OptimisticGovernor',
    address: '0x80bCA2E1c272239AdFDCdc87779BC8Af6E12e633',
    deployBlock: 13062540,
    subgraph:
      'https://subgrapher.snapshot.org/subgraph/arbitrum/H1WyWZqh5pHebWRDCXs7GhvGj7XznSP7arPY6pYcCqLn'
  },
  {
    // sepolia
    network: '11155111',
    name: 'OptimisticGovernor',
    address: '0x40153DdFAd90C49dbE3F5c9F96f2a5B25ec67461',
    deployBlock: 5421242,
    subgraph:
      'https://subgrapher.snapshot.org/subgraph/arbitrum/5pwrjCkpcpCd79k9MBS5yVgnsHQiw6afvXUfzqHjdRFw'
  },
] as const;

export const transactionTypes = [
  'transferFunds',
  'transferNFT',
  'contractInteraction',
  'raw',
  'safeImport'
] as const;

export const solidityZeroHexString =
  '0x0000000000000000000000000000000000000000000000000000000000000000';
